/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Interval_LabelInputs */

const en_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Interval (minutes)`)
};

const fr_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalle d'enregistrement (minutes)`)
};

const de_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speicherintervall (Minuten)`)
};

const it_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo di salvataggio (minuti)`)
};

const ru_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Интервал сохранения (минуты)`)
};

const es_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo de guardado (minutos)`)
};

const zh_cn2_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存间隔（分钟）`)
};

const ja_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存間隔（分）`)
};

const hi_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेव करने का अंतराल (मिनटों में)`)
};

const pt_pt2_options_backup_save_interval_label = /** @type {(inputs: Options_Backup_Save_Interval_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo de salvamento (minutos)`)
};

/**
* | output |
* | --- |
* | "Save Interval (minutes)" |
*
* @param {Options_Backup_Save_Interval_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_interval_label = /** @type {((inputs?: Options_Backup_Save_Interval_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Interval_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_save_interval_label(inputs)
	if (locale === "de") return de_options_backup_save_interval_label(inputs)
	if (locale === "it") return it_options_backup_save_interval_label(inputs)
	if (locale === "ru") return ru_options_backup_save_interval_label(inputs)
	if (locale === "es") return es_options_backup_save_interval_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_save_interval_label(inputs)
	if (locale === "ja") return ja_options_backup_save_interval_label(inputs)
	if (locale === "hi") return hi_options_backup_save_interval_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_save_interval_label(inputs)
	return en_options_backup_save_interval_label(inputs)
});